
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"},"content":"<path d=\"M4.69 9.806l-1.669 1.439.343-.645V6.334C3.364 3.389 5.908 1 9.045 1a5.85 5.85 0 014.03 1.576l-.973.839a4.454 4.454 0 00-3.057-1.198c-2.405 0-4.355 1.861-4.355 4.157v3.432zM14.728 6.42v4.18L17 14.866h-5.17C11.567 16.084 10.421 17 9.046 17c-1.374 0-2.52-.916-2.783-2.134H4.932l1.41-1.216h8.693l-1.633-3.118V7.563l1.326-1.143zM1.927 16.097L1 14.958 15.98 1.43l.927 1.139-14.98 13.528zm7.119-.255c.615 0 1.132-.37 1.327-.885H7.719c.195.515.712.885 1.327.885z\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
